'use client';

import type { TranslationSnapshotBoundaryComponent } from '@eliadmin/core/src/i18n/translation-snapshot-types';
import dynamic from 'next/dynamic';

const DictionaryBoundary0 = dynamic(() => import('./providers/dictionary-89b12f6345b52d31f086bfa12a9380e4df9bd3a4403770156858718b365f8085'));
const DictionaryBoundary1 = dynamic(() => import('./providers/dictionary-ad4fb37537f2c8558384d250726a2d8bdf6e08894930d776f7a5c4858e327b7c'));
const DictionaryBoundary2 = dynamic(() => import('./providers/dictionary-a62c2d3691974441a9f8493e7dd64fccbc07508ce33b70b0580eb7692fe86da3'));
const DictionaryBoundary3 = dynamic(() => import('./providers/dictionary-6f0f504758f319af60d914631457f7639656f7ec70a9fde673bbbdc695436226'));
const DictionaryBoundary4 = dynamic(() => import('./providers/dictionary-7af93f13990d3659ba46c4a8c5adbf0bc394e782898d13ad28bae2024b7ef3aa'));
const DictionaryBoundary5 = dynamic(() => import('./providers/dictionary-7aeab3f66141785e5c6ff4e96fd7279a5a39843616512d93b9c6ed7adc08f4fc'));
const DictionaryBoundary6 = dynamic(() => import('./providers/dictionary-848705ad8468c6ac3a5652e4cdf33b9e5464cc5f9e9209ef89fa2eb4c4a342d1'));
const DictionaryBoundary7 = dynamic(() => import('./providers/dictionary-a5af59b07c51908cf981f811b7a3234cc45cc1e52022d1e8f751364f40ad73fd'));
const DictionaryBoundary8 = dynamic(() => import('./providers/dictionary-dc5cefa0f86a717c300d525e2c079b7a481d7bd918b07c8d83399164269eaa03'));
const DictionaryBoundary9 = dynamic(() => import('./providers/dictionary-133df795d4804cd493018c615724c5486863056285040576e9b429c64a31fd29'));
const DictionaryBoundary10 = dynamic(() => import('./providers/dictionary-67572ee4a83729800672d37fd2c483480e969876bea467cc7715c752d9aa22cd'));
const DictionaryBoundary11 = dynamic(() => import('./providers/dictionary-0d1667116778471f4ba0b6e0f14582ff30bb5d4e3eaf722fc445e611185de91a'));
const DictionaryBoundary12 = dynamic(() => import('./providers/dictionary-6a1259ed8e03d2c2e00e847b28a64d4c8aba52f2b7e196d4c354dac54b31fe79'));
const DictionaryBoundary13 = dynamic(() => import('./providers/dictionary-229f99410090bb97e6365da8eef719e90975233e5a25f1a207fa75c2b8d44430'));
const DictionaryBoundary14 = dynamic(() => import('./providers/dictionary-ea1eca4fb8f2345858ead7244953d637298c79345223ca3d2221e3e1eb54f70c'));

export const GENERATED_TRANSLATION_BOUNDARIES: Readonly<Record<string, TranslationSnapshotBoundaryComponent>> = {
  "sk": DictionaryBoundary0,
  "cs": DictionaryBoundary1,
  "en": DictionaryBoundary2,
  "pl": DictionaryBoundary3,
  "hu": DictionaryBoundary4,
  "es": DictionaryBoundary5,
  "fr": DictionaryBoundary6,
  "hr": DictionaryBoundary7,
  "it": DictionaryBoundary8,
  "de": DictionaryBoundary9,
  "be": DictionaryBoundary0,
  "bg": DictionaryBoundary0,
  "gr": DictionaryBoundary0,
  "se": DictionaryBoundary10,
  "fi": DictionaryBoundary11,
  "dk": DictionaryBoundary0,
  "nr": DictionaryBoundary0,
  "ru": DictionaryBoundary12,
  "ro": DictionaryBoundary13,
  "nl": DictionaryBoundary0,
  "si": DictionaryBoundary14,
  "at": DictionaryBoundary0,
  "br": DictionaryBoundary0,
  "pt": DictionaryBoundary0,
  "ua": DictionaryBoundary0,
  "tr": DictionaryBoundary0,
  "ee": DictionaryBoundary0,
  "lv": DictionaryBoundary0,
  "us": DictionaryBoundary0,
  "au": DictionaryBoundary0,
  "ca": DictionaryBoundary0,
  "ch": DictionaryBoundary0,
  "in": DictionaryBoundary0,
  "jp": DictionaryBoundary0,
  "mx": DictionaryBoundary0,
  "rs": DictionaryBoundary0,
  "ba": DictionaryBoundary0,
  "lt": DictionaryBoundary0,
};
